import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var archiveListRes;
export const archiveListTodo = createAsyncThunk('archiveList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/view_archive_course_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_code": data,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return archiveListRes = res.data
    } catch (error) {
        return archiveListRes = error.response.data
    }
})


const archiveListSlice = createSlice({
    name: 'archiveList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(archiveListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('archiveList', state.data)
            }
        });
        builder.addCase(archiveListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default archiveListSlice.reducer; 